import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'pixlie.cookie_ack_v2';

/**
 * Small glass cookie notice (Gemini-style “why we use cookies”), non-blocking.
 */
export const CookieConsentBanner: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== '1') setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  if (!open) return null;

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* noop */
    }
    setOpen(false);
  };

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-[70] flex justify-center p-3 sm:p-4"
      role="dialog"
      aria-label="Cookie notice"
    >
      <div
        className={[
          'pointer-events-auto w-full max-w-lg',
          'rounded-2xl border border-border/60',
          'bg-[color-mix(in_srgb,var(--card)_72%,transparent)]',
          'shadow-raised backdrop-blur-xl backdrop-saturate-150',
          'px-4 py-3 sm:px-4 sm:py-3.5',
        ].join(' ')}
      >
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
          <div className="min-w-0 flex-1">
            <p className="text-xs font-semibold text-foreground">We use cookies</p>
            <p className="mt-1 text-[11px] leading-4 text-muted-foreground">
              Essential cookies keep you signed in, prevent abuse, and protect the product. Optional
              analytics stay anonymized when enabled — we don’t sell your content.{' '}
              <a href="/privacy/" className="underline underline-offset-2 hover:text-foreground">
                Privacy
              </a>
            </p>
          </div>
          <button
            type="button"
            onClick={accept}
            className="shrink-0 rounded-xl border border-border/70 bg-[color-mix(in_srgb,var(--surface-2)_80%,transparent)] px-4 py-2 text-xs font-semibold text-foreground transition hover:bg-[var(--surface-2)]"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
